import { getFormattedDate } from "../utils/getFormattedDate";

import { compOnlyCoverageCig, compOnlyExcessCoverageCig, liabilityCoverageCig } from "./builders/coverages";
import { createPoliciesMap } from "./builders/createPoliciesMap";
import { getMockDrivers } from "./builders/getMockDrivers";
import { getMockPolicyAddressCig } from "./builders/getMockPolicyAddress";
import { getMockVehicles } from "./builders/getMockVehicles";

export const mockPolicies = createPoliciesMap({
  abc123: {
    source: "CORE",
    country: "USA",
    premium: 5000,
    stateRegion: "MD",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra", "superBee"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  def456: {
    source: "CORE",
    country: "USA",
    premium: 15000,
    stateRegion: "KS",
    hasIdCard: true,
    isAutoPay: true,
    policyStatus: "ISSUED",
    policyCoverages: compOnlyCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("ferrari"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  ghi789: {
    source: "CORE",
    country: "USA",
    premium: 10000,
    stateRegion: "AZ",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("superBee"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  dc101: {
    source: "CORE",
    country: "CANADA",
    premium: 51,
    stateRegion: "QC",
    hasIdCard: true,
    isAutoPay: true,
    policyStatus: "ISSUED",
    policyCoverages: compOnlyCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("sportScoutRacer"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  dc102: {
    source: "CORE",
    country: "CANADA",
    premium: 60,
    stateRegion: "NS",
    hasIdCard: false,
    isAutoPay: false,
    policyStatus: "ISSUED",
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  dc103: {
    source: "CORE",
    country: "CANADA",
    premium: 100,
    stateRegion: "NB",
    hasIdCard: false,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "PL674825-01": {
    source: "CORE",
    country: "USA",
    premium: 4000,
    stateRegion: "MI",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("crv"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "5R34843-00": {
    // Old Policy version
    source: "CORE",
    country: "USA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: -20 }),
    expirationDate: getFormattedDate({ months: -8 }),
    stateRegion: "MD",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "CANCELED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "5R34843-01": {
    // Current version
    source: "CORE",
    country: "USA",
    premium: 5000,
    stateRegion: "MD",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "5R34843-02": {
    // Future version
    source: "CORE",
    country: "USA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: 4 }),
    expirationDate: getFormattedDate({ months: 16 }),
    stateRegion: "MD",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "7K903235-00": {
    // Old Policy version
    source: "CORE",
    country: "USA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: -20 }),
    expirationDate: getFormattedDate({ months: -8 }),
    stateRegion: "CT",
    hasIdCard: true,
    isAutoPay: true,
    policyStatus: "CANCELED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "7K903235-01": {
    // Current version
    source: "CORE",
    country: "USA",
    premium: 5000,
    stateRegion: "CT",
    hasIdCard: true,
    isAutoPay: true,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "7K903235-02": {
    // Future version
    source: "CORE",
    country: "USA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: 4 }),
    expirationDate: getFormattedDate({ months: 16 }),
    stateRegion: "MD",
    hasIdCard: true,
    isAutoPay: true,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "EA108939-00": {
    // Old Policy version
    source: "CORE",
    country: "USA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: -20 }),
    expirationDate: getFormattedDate({ months: -8 }),
    stateRegion: "GA",
    hasIdCard: false,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("sportScoutRacer"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "EA108939-01": {
    // Current version
    source: "CORE",
    country: "USA",
    premium: 5000,
    stateRegion: "GA",
    hasIdCard: false,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "EA108939-02": {
    // Future version
    source: "CORE",
    country: "USA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: 4 }),
    expirationDate: getFormattedDate({ months: 16 }),
    stateRegion: "GA",
    hasIdCard: false,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "0P456325-00": {
    // Old Policy version
    source: "CORE",
    country: "USA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: -20 }),
    expirationDate: getFormattedDate({ months: -8 }),
    stateRegion: "FL",
    hasIdCard: false,
    isAutoPay: true,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("sportScoutRacer"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "0P456325-01": {
    // Current version
    source: "CORE",
    country: "USA",
    premium: 5000,
    stateRegion: "FL",
    hasIdCard: false,
    isAutoPay: true,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "0P456325-02": {
    // Future version
    source: "CORE",
    country: "USA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: 4 }),
    expirationDate: getFormattedDate({ months: 16 }),
    stateRegion: "FL",
    hasIdCard: false,
    isAutoPay: true,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "CU723189-01": {
    // Canceled US policy
    source: "CORE",
    country: "USA",
    premium: 5000,
    stateRegion: "CA",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "CANCELED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "MC934852-01": {
    source: "CORE",
    country: "CANADA",
    premium: 4000,
    stateRegion: "ON",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: compOnlyExcessCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("superBee"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "CD829471-00": {
    // Old Policy version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: -20 }),
    expirationDate: getFormattedDate({ months: -8 }),
    stateRegion: "BC",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "CANCELED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: compOnlyExcessCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("crv"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "CD829471-01": {
    // Current version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    stateRegion: "BC",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: compOnlyExcessCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("crv"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "CD829471-02": {
    // Future version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: 4 }),
    expirationDate: getFormattedDate({ months: 16 }),
    stateRegion: "BC",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: compOnlyExcessCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("crv"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "AM345634-00": {
    // Old Policy version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: -20 }),
    expirationDate: getFormattedDate({ months: -8 }),
    stateRegion: "MB",
    hasIdCard: true,
    isAutoPay: true,
    policyStatus: "CANCELED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: compOnlyExcessCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("crv"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "AM345634-01": {
    // Current version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    stateRegion: "MB",
    hasIdCard: true,
    isAutoPay: true,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: compOnlyExcessCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("crv"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "AM345634-02": {
    // Future version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: 4 }),
    expirationDate: getFormattedDate({ months: 16 }),
    stateRegion: "MB",
    hasIdCard: true,
    isAutoPay: true,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: compOnlyExcessCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("crv"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "RG263345-00": {
    // Old Policy version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: -20 }),
    expirationDate: getFormattedDate({ months: -8 }),
    stateRegion: "AB",
    hasIdCard: false,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra", "mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "RG263345-01": {
    // Current version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    stateRegion: "AB",
    hasIdCard: false,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra", "mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "RG263345-02": {
    // Future version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: 4 }),
    expirationDate: getFormattedDate({ months: 16 }),
    stateRegion: "AB",
    hasIdCard: false,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra", "mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "NT432345-00": {
    // Old Policy version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: -20 }),
    expirationDate: getFormattedDate({ months: -8 }),
    stateRegion: "SK",
    hasIdCard: false,
    isAutoPay: true,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra", "mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "NT432345-01": {
    // Current version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    stateRegion: "SK",
    hasIdCard: false,
    isAutoPay: true,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra", "mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "NT432345-02": {
    // Future version
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    effectiveDate: getFormattedDate({ months: 4 }),
    expirationDate: getFormattedDate({ months: 16 }),
    stateRegion: "SK",
    hasIdCard: false,
    isAutoPay: true,
    policyStatus: "ISSUED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("cobra", "mustang"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  "CC723641-01": {
    // Canceled canadian policy
    source: "CORE",
    country: "CANADA",
    premium: 5000,
    stateRegion: "QC",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "CANCELED",
    agency: { id: 3000, name: "Mr Broker Man" },
    policyCoverages: compOnlyExcessCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("crv"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
  },
  // State Farm policy
  "0193845SCP01-00": {
    source: "CORE",
    country: "USA",
    premium: 479.62,
    stateRegion: "AZ",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    agency: { id: 7000, name: "Mr State Farm Broker" },
    policyCoverages: liabilityCoverageCig,
    additionalCoverages: [],
    vehicles: getMockVehicles("ferrari"),
    drivers: getMockDrivers(),
    policyAddress: getMockPolicyAddressCig(),
    carrier: "State Farm",
  },
  apex123: {
    source: "APEX",
    country: "USA",
    premium: 5000,
    stateRegion: "MI",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    policyCoverages: [],
    additionalCoverages: [],
    drivers: getMockDrivers(),
    vehicles: getMockVehicles("cobra", "superBee"),
  },
  apex456: {
    source: "APEX",
    country: "USA",
    premium: 10000,
    effectiveDate: getFormattedDate({ months: -2 }),
    expirationDate: getFormattedDate({ months: 10 }),
    stateRegion: "GA",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    policyCoverages: [],
    additionalCoverages: [],
    drivers: getMockDrivers(),
    vehicles: getMockVehicles("crv"),
  },
  apex789: {
    source: "APEX",
    country: "USA",
    premium: 100000,
    stateRegion: "TX",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    policyCoverages: [],
    additionalCoverages: [],
    drivers: getMockDrivers(),
    vehicles: getMockVehicles("ferrari"),
  },
  apexCan001: {
    source: "APEX",
    country: "CANADA",
    premium: 20000,
    stateRegion: "AB",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    policyCoverages: [],
    additionalCoverages: [],
    drivers: getMockDrivers(),
    vehicles: getMockVehicles("mustang"),
  },
  apexCan002: {
    source: "APEX",
    country: "CANADA",
    premium: 40000,
    stateRegion: "BC",
    effectiveDate: getFormattedDate({ months: -11 }),
    expirationDate: getFormattedDate({ months: 1 }),
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    policyCoverages: [],
    additionalCoverages: [],
    drivers: getMockDrivers(),
    vehicles: getMockVehicles("crv", "cobra"),
  },
  apexCan003: {
    source: "APEX",
    country: "CANADA",
    premium: 25000,
    stateRegion: "NS",
    hasIdCard: true,
    isAutoPay: false,
    policyStatus: "ISSUED",
    policyCoverages: [],
    additionalCoverages: [],
    drivers: getMockDrivers(),
    vehicles: getMockVehicles("superBee"),
  },
});

export type MockPolicyId = keyof typeof mockPolicies;
